import { DefaultError, QueryClient, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { passengerCMSApi } from "~/Services";

export interface DocumentDetailsResponse {
  id: string;
  Image: string;
  welcomeText: string;
  welcome_text_ms: string;
  welcome_text_zh: string;
  subText: string;
  sub_text_ms: string;
  sub_text_zh: string;
  androidTextMs: string;
  androidTextZh: string;
  androidQrImage: string;
  iosQrImage: string;
  androidText: string;
  iosText: string;
  iosTextMs: string;
  iosTextZh: string;
  androidLink: string;
  iosLink: string;
  scan_description_en: string;
  meta_title_en: string;
  meta_desc_en: string;
  metadataImage: string;
}

const fetchAppHeaderDetails = async (airport: string | null): Promise<DocumentDetailsResponse> => {
  if (!airport) throw new Error("Airport not found");
  const response = await passengerCMSApi.get(`/api/get-mobile-app-header?airport=${airport}`);
  return response.data[0];
};

const useAppHeaderDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  const [currentAirport] = useLocalStorage("currentAirport", null);
  return useQuery<DocumentDetailsResponse, DefaultError>(
    {
      queryKey: ["AppHeaderDocumentDetails", id, currentAirport],
      enabled: !!id && !!currentAirport,
      queryFn: () => fetchAppHeaderDetails(currentAirport),
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useAppHeaderDocumentDetails };
